/**
 * Replaces the URL hash without triggering Vue Router navigation.
 *
 * @sideeffect Modifies browser URL history state
 *
 * @description These functions calls history.replaceState() or history.pushState() directly
 * to prevent mounted() lifecycle hooks from being triggered again, which would happen
 * if using $router.replace() & $router.push() instead.
 *
 */

/**
 * Set hash with history.replaceState()
 *
 * @param {string} newHash - The new hash to set (with or without # prefix)
 */
export function replaceHash (newHash) {
  if (location.hash === newHash) {
    return
  }

  let newUrl = newHash
  if (newHash.length === 0) {
    newUrl = location.pathname + location.search
  } else if (false === newHash.startsWith('#')) {
    newUrl = '#' + newHash
  }

  history.replaceState('', '', newUrl)
}

/**
 * Set query string with history.replaceState()
 *
 * @param {object} query - query parameters in object format
 */
export function replaceQuery (query) {
  const url = new URL(location.href)

  Object.entries(query).forEach(([key, value]) => {
    url.searchParams.set(key, value)
  })

  history.replaceState({}, null, url.toString())
}

/**
 * Set query string with history.pushState()
 *
 * @param {object} query - query parameters in object format
 */
export function pushQuery (query) {
  const url = new URL(location.href)

  Object.entries(query).forEach(([key, value]) => {
    url.searchParams.set(key, value)
  })

  history.pushState({}, null, url.toString())
}
